import React from 'react';

/**
 * Hoi Buur Almere — Color block placeholder using pre-designed SVG variations.
 * Each activity category maps to a unique branded SVG with diagonal background
 * + Hoi Buur logo in matching brand book colors.
 */

const PLACEHOLDER_MAP = {
  sport:       '/images/colorblock-placeholders/01_blauw-koraal_peach-groen.svg',
  natuur:      '/images/colorblock-placeholders/02_geel-groen_blauw-koraal.svg',
  kunst:       '/images/colorblock-placeholders/03_koraal-lavendel_geel-blauw.svg',
  gezondheid:  '/images/colorblock-placeholders/04_groen-blauw_koraal-geel.svg',
  kinderen:    '/images/colorblock-placeholders/05_roze-geel_groen-blauw.svg',
  educatie:    '/images/colorblock-placeholders/06_lavendel-koraal_groen-geel.svg',
  muziek:      '/images/colorblock-placeholders/07_geel-roze_blauw-peach.svg',
  sociaal:     '/images/colorblock-placeholders/08_blauw-geel_koraal-groen.svg',
  ouderen:     '/images/colorblock-placeholders/09_groen-koraal_lavendel-peach.svg',
  eten:        '/images/colorblock-placeholders/10_peach-blauw_geel-roze.svg',
  tech:        '/images/colorblock-placeholders/03_koraal-lavendel_geel-blauw.svg',
};

const DEFAULT_PLACEHOLDER = '/images/colorblock-placeholders/01_blauw-koraal_peach-groen.svg';

const ColorBlockPlaceholder = ({ activityType = 'sociaal', className = '' }) => {
  const src = PLACEHOLDER_MAP[activityType] || DEFAULT_PLACEHOLDER;

  return (
    <div
      className={`relative w-full aspect-[4/3] overflow-hidden ${className}`}
      data-testid="color-block-placeholder"
      aria-hidden="true"
    >
      <img
        src={src}
        alt=""
        className="w-full h-full object-cover"
        draggable="false"
      />
    </div>
  );
};

export default ColorBlockPlaceholder;
